import { Component, ViewChild, OnInit, ElementRef, AfterViewInit } from '@angular/core';
import { Demande, Modes } from '../model/demande';
import { Context } from '../model/context';
import { ActivatedRoute } from '@angular/router';
import { MatStepper } from '@angular/material/stepper';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Creneau } from '../model/creneau';

import Swal from 'sweetalert2/dist/sweetalert2.js';
import { PublicService } from '../services/public.service';
import { Upload } from '../model/upload';

@Component({
  selector: 'app-questionnaire',
  templateUrl: './questionnaire.component.html',
  styleUrls: ['./questionnaire.component.css']
})
export class QuestionnaireComponent implements OnInit {
  
  @ViewChild('verticalStepper') stepper: MatStepper;

  ready = false;
  demande: Demande;
  context: Context;

  constructor(private el: ElementRef, private route: ActivatedRoute, private publicService: PublicService) { }

  ngOnInit() {
    this.demande = new Demande();

    this.demande.mode = Modes.PARTICULIER;

    this.route.data.subscribe(data => {
      this.context = data.context;
      if (this.context.primaryColor != null && this.context.accentColor != null)
        this.initCSS(this.context.primaryColor, this.context.accentColor, this.context.bgColor);

      this.computeCreneaux();
      
      this.ready = true;        
    })
  }

  computeCreneaux() {
    let tmp: Creneau[] = [];
    this.context.cibles.filter(t => t.selected).forEach(t => {
      t.creneaux.forEach(c => {
        let current: Creneau = null;
        tmp.filter(cTmp => cTmp.jour == c.jour).find(cTmp => current = cTmp);

        if (current == null) {
          current = new Creneau(c.jour, c.debut, c.fin, c.debut, c.fin);
          tmp.push(current);
        } else {
          if (current.debut > c.debut) {
            current.debut = c.debut
            current.min = c.debut;
          }
          if (current.fin < c.fin) {
            current.fin = c.fin;
            current.max = c.fin;
          }
        }
      });
    });
    this.demande.planning = tmp;
  }

  hasSelectedTarget(): boolean {
    let tmp = false || this.context.cibles.length == 0;
    this.context.cibles.forEach(t => tmp = tmp || t.selected);
    return tmp;
  }

  isHorairesValid(): boolean {
    let tmp = true;
    this.demande.planning.forEach(c => { if (c.debut > c.fin) tmp = false; });        
    return tmp;
  }

  send() {
    this.demande = new Demande();
    this.computeCreneaux();
    if (this.stepper != undefined) this.stepper.selectedIndex = 0;
  }

  initCSS(mainColor: string, accentColor: string, bgColor: string) {
    const styleElement = document.createElement('style');
    styleElement.appendChild(document.createTextNode(".selection > img { max-width: 100% }"));
    styleElement.appendChild(document.createTextNode(".mat-title { color: " + mainColor + " !important; }"));
    styleElement.appendChild(document.createTextNode(".mat-step-header .mat-step-icon-selected, .mat-step-header .mat-step-icon-state-done, .mat-step-header .mat-step-icon-state-edit { background-color: " + mainColor + " !important; }"));
    styleElement.appendChild(document.createTextNode(".mat-form-field.mat-focused .mat-form-field-label { color: " + mainColor + " !important; }"));
    styleElement.appendChild(document.createTextNode(".mat-input-element { caret-color: " + mainColor + " !important; }"));
    styleElement.appendChild(document.createTextNode(".mat-focused .mat-form-field-label { color: " + mainColor + " !important; }"));
    styleElement.appendChild(document.createTextNode(".mat-form-field-ripple { background-color: " + mainColor + " !important; }"));
    styleElement.appendChild(document.createTextNode(".mat-step-header .mat-step-label.mat-step-label-active { color: " + mainColor + " !important; }"));
    styleElement.appendChild(document.createTextNode(".mat-flat-button.mat-primary, .mat-raised-button.mat-primary, .mat-fab.mat-primary, .mat-mini-fab.mat-primary { background-color: " + mainColor + " !important; }"));        
    styleElement.appendChild(document.createTextNode(".mat-checkbox-indeterminate.mat-accent .mat-checkbox-background, .mat-checkbox-checked.mat-accent .mat-checkbox-background { background-color: " + accentColor + " !important; }"));
    styleElement.appendChild(document.createTextNode(".mat-form-field-suffix { color: " + accentColor + " !important; }"));
    if (bgColor != null) styleElement.appendChild(document.createTextNode(".card-container { background: " + bgColor + " !important; }"));
    if (bgColor != null) styleElement.appendChild(document.createTextNode(".mat-card { background: transparent !important; }"));
    if (bgColor != null) styleElement.appendChild(document.createTextNode(".mat-stepper-vertical { background: transparent !important; }"));
    styleElement.appendChild(document.createTextNode(".section { border: 1px solid " + mainColor + " !important; }"));
    this.el.nativeElement.appendChild(styleElement);
  }

}
